import React, { Component } from 'react';
import './Captions.css';
// import Utility from '../../../Utility';
import { connect } from 'react-redux';

class Captions extends Component {

	findByTime = () => {
    	// index = @sortedIndex new @model(intime: time), (t) -> t.get 'intime'

		var captiontext = '',
			i = 0;

		while (i < this.props.data.recording.info.captions.length) {
			var caption = this.props.data.recording.info.captions[i],
				inTime = caption.intime,
				outTime = caption.outtime;

			if (this.props.dynamic.currentTime < inTime) {
				captiontext = '';
				break
			}

			if (this.props.dynamic.currentTime >= inTime && this.props.dynamic.currentTime <= outTime) {
				return caption.text;
			}

			i++;
		}

	    return captiontext;
	}

	render() {
		var captionText = this.findByTime().split('<br />');

		if (this.props.data.captions) {
			return(
				<div id="captions">
					{ captionText.map((text, index) => {
						return(<div key={index}>{text}</div>)
					}) }
				</div>
			);
		} else {
			return null;
		}
	}
}


const mapStateToProps = state => ({
	dynamic: state.dynamic
});

export default connect(mapStateToProps)(Captions);